'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.demand_report_show', {
    template: '<demand-report-show></demand-report-show>'
  }).state('main.demand_report_show.detail', {
    url: 'demand_report/:id',
    params: { type: null, term: null, target: null },
    views: {
      daily: {
        template: '<daily_demand_report></daily_demand_report>'
      },
      weekly: {
        template: '<weekly_demand_report></weekly_demand_report>'
      },
      monthly: {
        template: '<monthly_demand_report></monthly_demand_report>'
      },
      yearly: {
        template: '<yearly_demand_report></yearly_demand_report>'
      },
      daily_active: {
        template: '<daily-active-report></daily-active-report>'
      },
      weekly_active: {
        template: '<weekly-active-report></weekly-active-report>'
      },
      monthly_active: {
        template: '<monthly-active-report></monthly-active-report>'
      },
      yearly_active: {
        template: '<yearly-active-report></yearly-active-report>'
      },
      demand_histogram: {
        template: '<demand-histogram></demand-histogram>'
      },
      daily_price: {
        template: '<daily-price-report></daily-price-report>'
      },
      monthly_price: {
        template: '<monthly-price-report></monthly-price-report>'
      },
      event_report: {
        template: '<event-report></event-report>'
      }
    }
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/show/demand_report_show.routes.js